export enum ApiStatusEnum {
  success = 'success',
  warning = 'warning',
  error = 'error',
}
